import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';
import { Button } from '@mui/base/Button';
import classNames from 'classnames';
import { LoaderIcon, PlaceholderIcon } from '@cognite/cogs-icons';
import { getThemeClassNames, IconWrapper } from '@cognite/cogs-utils';

/**
 * Re-usable icon only button for internal use.
 * this only exist in x-small size
 */
var IconButton = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var disabled = _a.disabled,
    _a$icon = _a.icon,
    icon = _a$icon === undefined ? PlaceholderIcon : _a$icon,
    inverted = _a.inverted,
    loading = _a.loading,
    skeleton = _a.skeleton,
    toggled = _a.toggled,
    otherProps = __rest(_a, ["disabled", "icon", "inverted", "loading", "skeleton", "toggled"]);
  var Icon = icon;
  return jsxs(Button, Object.assign({
    focusableWhenDisabled: true,
    type: "button",
    ref: ref,
    disabled: disabled || loading,
    "aria-busy": loading,
    "aria-pressed": toggled,
    className: classNames.apply(undefined, ['cogs-v10', 'cogs-iconbutton', {
      'cogs-iconbutton--skeleton': skeleton
    }, 'cogs-iconbutton--size-x-small', 'cogs-iconbutton--icon-only', {
      'cogs-iconbutton--loading': loading && !skeleton
    }, {
      'cogs-iconbutton--disabled': disabled && !skeleton
    }, {
      'cogs-iconbutton--toggled': toggled && !skeleton
    }].concat(getThemeClassNames(inverted)))
  }, otherProps, {
    children: [!loading && !skeleton && jsx(IconWrapper, {
      size: 12,
      children: jsx(Icon, {})
    }), loading && jsx(LoaderIcon, {})]
  }));
});

export { IconButton };
